module.exports = __webpack_public_path__ + "static/media/identidad_card_detail.f7014231.png";